import { render, staticRenderFns } from "./CustomBankDepositForm.vue?vue&type=template&id=618da8ff"
import script from "./CustomBankDepositForm.vue?vue&type=script&lang=js"
export * from "./CustomBankDepositForm.vue?vue&type=script&lang=js"
import style0 from "./CustomBankDepositForm.vue?vue&type=style&index=0&id=618da8ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports